import React from 'react';
import './Tag.scss';

const Tag = ({ title, link, color = null }) => {
  return (
    <span key={title} className={`c-tag ${color ? color : ''}`}>
      <a href={link}>{title}</a>
    </span>
  );
};

export default Tag;
